import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.d5b008f3-86d8-48d7-bec7-17d1f21f60a8/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins_home/workspace/tingle.d5b008f3-86d8-48d7-bec7-17d1f21f60a8/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.d5b008f3-86d8-48d7-bec7-17d1f21f60a8/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { templateLoader, Template } from '../../features/Template';
import { NotFound } from '../../features/Layout';
import { jsx as _jsx } from "react/jsx-runtime";
export var ArticlePage = function ArticlePage(_ref) {
  var template = _ref.template,
      preview = _ref.preview;

  if (!template) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }

  if (!preview && !publishedByDate(template)) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }

  return /*#__PURE__*/_jsx(Template, _objectSpread(_objectSpread({}, template), {}, {
    canonicalUrl: "/blog/".concat(template.urlSlug),
    preview: preview
  }));
};

ArticlePage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var smartlingLanguage, query, preview, urlSlug, template;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            smartlingLanguage = _ref2.smartlingLanguage, query = _ref2.query, preview = _ref2.preview;
            urlSlug = typeof query.urlSlug === 'string' ? query.urlSlug : query.urlSlug.join('/');
            _context.next = 4;
            return templateLoader.load({
              contentType: 'articlePage',
              urlSlug: urlSlug,
              smartlingLanguage: smartlingLanguage,
              preview: preview
            });

          case 4:
            template = _context.sent;
            return _context.abrupt("return", {
              template: template,
              preview: preview
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

function publishedByDate(template) {
  if (template.releaseDate) {
    var parsedReleaseDate = new Date(template.releaseDate);
    return parsedReleaseDate ? parsedReleaseDate < new Date() : false;
  }

  return true;
}

export default ArticlePage;